import React, { useState, useEffect } from 'react';
import { Extra } from '../types';
import { XIcon } from './icons';

interface ExtraFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (extra: Extra) => void;
    extraToEdit?: Extra | null;
    isSaving?: boolean;
}

const ExtraFormModal: React.FC<ExtraFormModalProps> = ({
    isOpen,
    onClose,
    onSave,
    extraToEdit,
    isSaving = false
}) => {
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');

    useEffect(() => {
        if (extraToEdit) {
            setName(extraToEdit.name);
            setPrice(extraToEdit.price.toString());
        } else {
            setName('');
            setPrice('');
        }
    }, [extraToEdit, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave({
            id: extraToEdit?.id || Date.now().toString(),
            name,
            price: Number(price)
        });
    };

    return (
        <div className="fixed inset-0 z-[1100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
            <div className="bg-white rounded-[2rem] w-full max-w-md shadow-2xl animate-scale-in overflow-hidden">
                <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
                    <h2 className="text-xl font-black text-gray-900">
                        {extraToEdit ? 'Modifier l\'Extra' : 'Ajouter un Extra'}
                    </h2>
                    <button onClick={onClose} className="p-2 hover:bg-white rounded-full transition-colors text-gray-400">
                        <XIcon className="w-5 h-5" />
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="p-6 space-y-6">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-2 ml-1">
                                Nom de l'extra
                            </label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-green-500 focus:bg-white transition-all font-bold text-gray-800"
                                placeholder="ex: Fromage supplémentaire, Sauce..."
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] mb-2 ml-1">
                                Prix (DA)
                            </label>
                            <input
                                type="number"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                className="w-full px-5 py-4 bg-gray-50 border border-gray-100 rounded-2xl focus:ring-2 focus:ring-green-500 focus:bg-white transition-all font-bold text-gray-800"
                                placeholder="0"
                                required
                            />
                        </div>
                    </div>

                    <div className="pt-4 flex gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="flex-1 py-4 px-6 border border-gray-100 text-gray-500 font-black rounded-2xl hover:bg-gray-50 transition-all text-xs uppercase tracking-widest"
                        >
                            Annuler
                        </button>
                        <button
                            type="submit"
                            disabled={isSaving}
                            className="flex-[2] py-4 px-6 bg-green-600 text-white font-black rounded-2xl shadow-xl shadow-green-100 hover:bg-green-700 active:scale-95 transition-all text-xs uppercase tracking-widest disabled:opacity-50"
                        >
                            {isSaving ? 'ENREGISTREMENT...' : (extraToEdit ? 'METTRE À JOUR' : 'AJOUTER L\'EXTRA')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ExtraFormModal;
